"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumServiceGroupingSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const combine_labels_1 = require("../../utils/combine-labels");
const meta_data_1 = require("../base/meta-data");
exports.SourgumServiceGroupingSchema = {
    name: 'sourgum-service-grouping',
    alias: 'Sourgum Grouping',
    shortName: 'Service',
    applications: ['aap', 'customer-portal'],
    disabled: false,
    returnType: {
        aap: transport_types_1.UniversalService.ServiceGrouping,
        'customer-portal': transport_types_1.UniversalService.ServiceGroupingCustomerTransport,
    },
    searchableAttributes: [
        {
            field: 'serviceOrders.serviceLocation.address.addressLine1',
            alias: 'Service Location Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'serviceOrders.serviceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'serviceOrders.serviceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'serviceOrders.serviceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'serviceOrders.serviceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'serviceOrders.serviceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'serviceOrders.vendorName',
            alias: 'Vendor Name',
            shortName: 'Vendor',
            searchableByDefault: false,
            disabledOn: ['customer-portal'],
        },
        {
            field: 'orderNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
            boost: 1.5,
        },
        {
            field: 'serviceOrders.poNumber',
            alias: 'PO Number',
            shortName: 'PO Number',
            searchableByDefault: true,
        },
        /*     {
          field: 'accountManagerName',
          alias: 'Account Manager Name',
          shortName: 'am',
          searchableByDefault: false,
        },
        {
          field: 'accountRepName',
          alias: 'Account Executive Name',
          shortName: 'ae',
          searchableByDefault: false,
        }, */
    ],
    filterableAttributes: [
        {
            field: 'serviceOrders.startDate',
            alias: 'Start Date',
            shortName: 'Start Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
            needsDeterministicSorting: true,
        },
        {
            field: 'serviceOrders.endDate',
            alias: 'End Date',
            shortName: 'End Date',
            type: 'DATE',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
            needsDeterministicSorting: true,
        },
        {
            field: 'serviceOrders.status',
            alias: 'Order Status',
            shortName: 'Status',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: {
                aap: (0, combine_labels_1.combineLabels)(transport_types_1.UniversalService.ServiceOrderStatuses.map((key) => ({
                    value: String(key),
                    label: transport_types_1.UniversalService.ServiceOrderStatusLabels[key],
                }))),
                'customer-portal': (0, combine_labels_1.combineLabels)(transport_types_1.UniversalService.ServiceOrderStatuses.map((key) => ({
                    value: String(key),
                    label: transport_types_1.UniversalService.ServiceOrderStatusLabels[key],
                }))),
            },
            allowsMultipleValues: true,
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=sourgum-service-grouping.js.map